export const TRUE = 1
export const FALSE = 2

export const ENABLED = 1
export const DISABLED = 2

export const USERNAME_MIN_LENGTH = 6
export const USERNAME_MAX_LENGTH = 10
export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 20

export const TAG_VIDEO = 1
export const TAG_COMIC = 2

export const VideoTypeEnum = {
  LongVideo: 1,
  ShortVideo: 2,
  Comic: 3,
}

export const NAV_TYPE_NORMAL = 1
export const NAV_TYPE_GAME = 2
export const NAV_TYPE_DISCOVER = 3
export const NAV_TYPE_ACCOUNT = 4
export const NAV_TYPE_APPLICATIONS = 5

export const NAV_ALIGN_LEFT = 1
export const NAV_ALIGN_CENTER = 2
export const NAV_ALIGN_RIGHT = 3

export const SAVE_ID_KEY = 'save_id'
export const SHOW_SAFETY_KEY = 'show_safety'
export const NOTICE_POPUP_DISMISSED_DATE_KEY = 'notice_popup_dismissed_date'
export const IDCARD_POPUP_DISMISSED_DATE_KEY = 'idcard_popup_dismissed_date'
export const NOTICE_POPUP_ID = '1'
export const IDCARD_POPUP_ID = '2'

export const PRELOAD_DATA_LOCAL_STORAGE_KEY = 'pd'
